import styled from "styled-components";

interface IItem {
  isShowed?: boolean
}

export const Container = styled.div``

export const ItemTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 160%;
  color: #2A2637;
  cursor: pointer;
  
  @media (min-width: 980px) {
    font-size: 20px;
    line-height: 140%;
  }
`

export const ArrowIcon = styled.div<IItem>`
  transform: rotate(180deg);
  width: 20px;
  height: 20px;
  left: 0;
  position: absolute;
  top: 50%;
  margin-top: -13px;

  ${({ isShowed }) => isShowed && `
    display: none
  `}
  
  svg path {
    stroke: #A8A4B9;
  }
`

export const ItemText = styled.div<IItem>`
  font-size: 14px;
  line-height: 170%;
  color: #2A2637;
  margin-top: 10px;
  transform-origin: top;
  transition: opacity .2s ease-in-out, visibility .2s ease-in-out;

  ${({ isShowed }) => isShowed && `
    opacity: 1;
    visibility: visible;
    transform: scaleY(100%);
    max-height: 1500px;
  ` || `
    opacity: 0;
    visibility: hidden;
    transform: scaleY(0);
    max-height: 0;
  `}

  a {
    color: #0D71D7;
  }
  
  @media (min-width: 980px) {
    font-size: 18px;
  }
`

export const Items = styled.div``

export const Item = styled.div<IItem>`
  padding: 0 24px;
  transition: .2s ease-in-out;
  border-radius: 8px;
  margin: 24px 0;
  position: relative;
  
  &:first-child {
    margin-top: 0;
  }
  
  &:last-child {
    margin-bottom: 0;
  }
  
  ${({ isShowed }) => isShowed && `
    background: #F7F7FA;
    padding: 24px;
  `}
`

